<script>
    export default {
        data(){
            return{
                userPermissions: [],
                allow: false
            }
        },
        computed:{
            currentPermissions(){
                // const user_data = sessionStorage.getItem ( 'user-info' ) ;
                const user_data = localStorage.getItem ( 'user' ) ;

                let user_data_json = JSON.parse(user_data);
                let permissions = user_data_json.permissions;
                return permissions;
            },
        },
        methods: {
            $can(currentUser){
                return JSON.stringify(this.currentPermissions).includes(currentUser);
            }
        }
    }
</script>